"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIssuesPlugin = void 0;
var _react = _interopRequireDefault(require("react"));
var _issuesReferencePickerPlugin = require("./issuesReferencePickerPlugin");
var _FiltersPanel = require("./FiltersPanel");
var _IssuesCustomDataView = _interopRequireDefault(require("./IssuesCustomDataView"));
var _FixedTypeExplainBanner = require("./FixedTypeExplainBanner");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * Calling this function generates a version of the issues reference picker plugin
 * with fixed filters
 *
 * Since the plugin itself is not modifiable enough
 * to allow for making a filter that cannot be modified,
 * the easiest way to do it is to bake it into the queryEntities call,
 * so all requests are filtered by the filters specified when this plugin is made.
 *
 * This way the issues reference picker will not let you clear the fixed filter, and it will always apply it.
 *
 * The creation modal, filters panel, and the top banner of the main view are all also modified.
 *
 * One thing to note: right now this only allows for fixing the type filter,
 * and there are some hardcoded user-facing phrases that refer to the form template manager.
 * ... if we want this to be used in other contexts, those phrases will need to be changeable
 */
const getIssuesPlugin = _ref => {
  let {
    fixedFilters
  } = _ref;
  const newIssuesPlugin = {
    ..._issuesReferencePickerPlugin.issuesReferencePickerPlugin
  };
  newIssuesPlugin.queryEntities = async options => {
    const modifiedOptions = {
      ...options,
      filters: {
        ...options.filters,
        ...fixedFilters
      }
    };
    return _issuesReferencePickerPlugin.issuesReferencePickerPlugin.queryEntities(modifiedOptions);
  };
  newIssuesPlugin.CreateNewEntityPanel = options => {
    const modifiedOptions = {
      ...options
    };
    if (fixedFilters !== null && fixedFilters !== void 0 && fixedFilters.issueTypeId) {
      modifiedOptions.fixedTypeId = fixedFilters === null || fixedFilters === void 0 ? void 0 : fixedFilters.issueTypeId[0];
    }
    return _issuesReferencePickerPlugin.issuesReferencePickerPlugin.CreateNewEntityPanel(modifiedOptions);
  };
  newIssuesPlugin.FiltersPanel = props => {
    const modifiedProps = {
      ...props
    };
    if (fixedFilters !== null && fixedFilters !== void 0 && fixedFilters.issueTypeId) {
      modifiedProps.fixedTypeId = fixedFilters === null || fixedFilters === void 0 ? void 0 : fixedFilters.issueTypeId[0];
    }
    return /*#__PURE__*/_react.default.createElement(_FiltersPanel.FiltersPanel, modifiedProps);
  };
  newIssuesPlugin.CustomDataView = props => {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (fixedFilters === null || fixedFilters === void 0 ? void 0 : fixedFilters.issueTypeId) && /*#__PURE__*/_react.default.createElement(_FixedTypeExplainBanner.FixedTypeExplainBanner, null), /*#__PURE__*/_react.default.createElement(_IssuesCustomDataView.default, props));
  };
  return newIssuesPlugin;
};
exports.getIssuesPlugin = getIssuesPlugin;
//# sourceMappingURL=getIssuesPlugin.js.map